import { makeApiEndpointConfig } from "../utils/endpoints.utils";
export var SupportGroupTopicEndpoints = {
    public: {
        index: makeApiEndpointConfig("/public/support-group-topics"),
    },
};
